module.exports = __webpack_public_path__ + "img/mtxy.19132999.jpg";